















import { Component, Prop, Vue } from "vue-property-decorator";
import { COLORS } from "@/app/constants";

@Component
export default class ColorPickerInput extends Vue {
  options: string[] = COLORS;

  @Prop({ required: true }) value!: string;

  change(value: string) {
    this.$emit("input", value);
  }
  mounted() {
    if (!this.options.includes(this.value.toUpperCase())) {
      this.options.push(this.value);
    }
  }
}
